import Axios, { AxiosError, AxiosRequestConfig } from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { ApiError } from 'api';
import { logout, setToken } from 'common/utils/roles';
import { notification } from 'components/layout/Notification/Notification';
import { BASE_PATH } from 'features/service/config';
import { APP_ERROR_TOKEN_EXPIRED, HTTP_ERROR_FORBIDDEN } from './responseCodes';

const REFRESH_TOKEN_URL = 'refresh-token';

const refreshAuthLogic = (failedRequest: AxiosError<ApiError>) => {
  if (failedRequest.response && failedRequest.response.status === HTTP_ERROR_FORBIDDEN) {
    if (failedRequest.response.data.code === APP_ERROR_TOKEN_EXPIRED) {
      return Axios.post(`${BASE_PATH}/auth/${REFRESH_TOKEN_URL}`)
        .then(tokenRefreshResponse => {
          tokenRefreshResponse?.headers.authorization && setToken(tokenRefreshResponse?.headers.authorization);
          return Promise.resolve();
        })
        .catch(e => {
          logout();
          notification({ type: 'warning', message: 'Ваша рабочая сессия истекла. Пожалуйста, войдите снова.' });
          return Promise.reject();
        });
    }
  }

  return Promise.reject(failedRequest);
};

createAuthRefreshInterceptor(Axios, refreshAuthLogic, { statusCodes: [HTTP_ERROR_FORBIDDEN] });

/** Interceptors */
export const intercept = () => {
  Axios.interceptors.request.use((config: AxiosRequestConfig) => {
    if (config.headers.hasOwnProperty('NOINTERCEPT')) {
      return config;
    }
    const authorizationToken = localStorage.getItem('token');

    config.withCredentials = true;

    /** Аутентификация */
    // Отправлять акцесс токен на рефреш не нужно, будет ошибка 403 (HTTP_ERROR_FORBIDDEN)
    if (authorizationToken && !config.url?.includes(REFRESH_TOKEN_URL)) {
      // /** Убрать все русские символы, так как в заголовках их отправлять нельзя */
      // config.headers.Authorization = token.replace(/[а-яА-Я]/g, '');
      config.headers.Authorization = authorizationToken;
    }
    // Локализация для ошибок
    config.headers['Accept-Language'] = 'ru';

    return config;
  });
  Axios.interceptors.response.use(
    response => response,
    async error => {
      const e = error as AxiosError<ApiError>;

      throw e.response?.data || error;
    },
  );
};
